export default [{
    path: '/lessons',
    name: 'lessons',
    component: () =>
        import ('@/views/pages/lessons/lessons-list/LessonsList.vue'),
    meta: {
        pageTitle: 'Lessons',
        breadcrumb: [{
            text: 'Lessons',
            active: true,
            to: '/lessons',
        }, ],
        resource: 'lesson',
        action: 'read',
    },
},
{
    path: '/lessons/view/:id',
    name: 'lessons-view',
    component: () =>
        import ('@/views/pages/lessons/lessons-view/LessonsView.vue'),
    meta: {
        pageTitle: 'View Lesson',
        breadcrumb: [
        {
            text: 'Lessons',
            to: '/lessons',
        },{
            text: 'View',
            active: true,
        } ],
        resource: 'lesson',
        action: 'read',
    },
},
{
    path: '/lessons/edit/:id',
    name: 'lessons-edit',
    component: () =>
        import ('@/views/pages/lessons/lessons-edit/LessonsEdit.vue'),
    meta: {
        pageTitle: 'Edit Lesson',
        breadcrumb: [
        {
            text: 'Lessons',
            to:'/lessons',
        },
        {
            text: 'Edit',
            active: true,
        } ],
        resource: 'lesson',
        action: 'read',
    },
},
{
    path: '/lessons/add',
    name: 'lessons-add',
    component: () =>
        import ('@/views/pages/lessons/lessons-add/LessonsAdd.vue'),
    meta: {
        pageTitle: 'Add Lesson',
        breadcrumb: [
        {
            text: 'Lessons',
            to:'/lessons',
        },
        {
            text: 'Add',
            active: true,
        } ],
        resource: 'lesson',
        action: 'read',
    },
},
]